import React, { useEffect, useState, memo, useMemo } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../../ErrorBoundry";
import visileColumns from "./visileColumns";
import { filterAllowedColumn } from "../../_helper/helper";
import { Alert, Container } from "reactstrap";
import TransactionTable from "./TransactionTable";
import { fetchPreviousTransaction, setLetestData } from "../../Components/Create Transaction/slices/ggTrackSlice";
import TelerikDataTable from "../TelerikDataTable";
import { sortingFunc } from "../CommonFunction";


const TransactionDataTable = (props) => {


  let {
    setOpenHistory,
    openHistory,
    EmployeeId,
    NOA,
  } = props;
  const dispatch = useDispatch();

  const { PreviousItem } = useSelector((state) => state.ggTrackSlice);
  const { previousData, rowCount, Loading } = PreviousItem;

  console.log("previousData in model", previousData)
  const [searchParams, setSearchParams] = useState([]);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");

  const [sortedColumns, setSortedColumns] = useState([]);
  const TransactionHistory = "Transaction History";
  const lastAdditionalWhere = useSelector((state) => state.CommonReducer);
  let newAdditionalWhere = lastAdditionalWhere?.additionalWhere[TransactionHistory];
  // const defaultQueryInitial = `EmployeeID LIKE ${EmployeeId ? EmployeeId : ""}`;
  // const sql73QueryInitial = `${defaultQueryInitial} AND NatureTitle LIKE 'SALARY INCREMENT'`;
  // const sql80QueryInitial = `EmployeeID LIKE '${EmployeeId ? EmployeeId : ""}' AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O'`;
  
  /************* Used for search when coming back from other screen for previous search data stored. */
  // const defaultQuery = `EmployeeID LIKE ${EmployeeId ? EmployeeId : ""}`; // ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;
  // const sql73Query = `${defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT'`; // ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;
  // const sql80Query = `EmployeeID LIKE '${EmployeeId ? EmployeeId : ""}' AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O'`; // ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  /************ last working but not proper after second time edit double query */
  // const defaultQuery = `EmployeeID LIKE '${EmployeeId ? EmployeeId : ""}'`;

  // const defaultQuery1 = `EmployeeID LIKE '${EmployeeId ? EmployeeId : ""}' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  // const sql73Query = `${newAdditionalWhere ? defaultQuery1 : defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;
  // const sql80Query = `${newAdditionalWhere ? defaultQuery1 : defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  // let generateQuery = NOA && NOA == "73" ? sql73Query : NOA == "80" ? sql80Query : defaultQuery;

  const defaultQuery = `EmployeeID LIKE ${EmployeeId ? EmployeeId : ""}`;

  const defaultQuery1 = `EmployeeID LIKE ${EmployeeId ? EmployeeId : ""} ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  const sql73Query = `${defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;
  const sql80Query = `${defaultQuery}` //`${defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;
  const sql51Query = `${defaultQuery} AND (NatureTitle LIKE 'ACTING APPOINTMENT' OR NatureTitle LIKE 'DETAIL APPOINTMENT') ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  // const sql73Query = `${newAdditionalWhere ? defaultQuery1 : defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  // const sql80Query = `${newAdditionalWhere ? defaultQuery1 : defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O' ${newAdditionalWhere && newAdditionalWhere !== undefined ? `AND ${newAdditionalWhere}` : ""}`;

  let generateQuery = NOA && NOA == "73" ? sql73Query : NOA == "80" ? sql80Query : NOA == "51" ? sql51Query : newAdditionalWhere ? defaultQuery1 : defaultQuery;

  const [additionalWhere, setAdditionalWhere] = useState(generateQuery);
  // const [newQueryData, setNewQueryData] = useState();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  // const [sortData, setSortData] = useState(
  //   [{ field: "EmployeeId", dir: "desc" }, { field: "HrControl", dir: "desc" }]
  // );
  const [historyData, setHistoryData] = React.useState([]);
  const [SortData, setSortData] = useState(
      [
        // { field: "EmployeeId", dir: "desc" },
        // { field: "HrControl", dir: "desc" }
      ]
    );

  console.log("sortedColumns",additionalWhere, newAdditionalWhere);

  useEffect(() => {
    if (EmployeeId) {
      let payload = {
        id: EmployeeId, page, pageSize, NOA, additionalWhere, sortData: SortData.reduce(
          (accumulator, item) =>
            (accumulator === "" ? " " : accumulator + ", ") +
            item.field +
            " " +
            item.dir,
          ""
        ),
        view : NOA == "80" ? "vw_MeritBonus_TransHistory" : "vw_GetAllDataByEmployee"
      }
      try {
        dispatch(fetchPreviousTransaction(payload));
      } catch (error) {
      }
    }
  }, [pageSize, page, additionalWhere, newAdditionalWhere, SortData])
 

  

  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
  };

  useEffect(() => {
    if (historyData.length > 0) {
      sortingFunc(SortData, historyData, setHistoryData);
    }
  }, [SortData]);

  const toggleDialog = () => {
    setOpenHistory(!openHistory);
  };

  // const handleFilterChange = (data) => {
  //   console.log("sortedcolums 121212  data",data, newAdditionalWhere)
  //   let defaultQuery1 = `${defaultQuery}${data ? " AND " + data : ""}`;
  //   let sql73Query1 = `${sql73Query}${data ? " AND " + data : ""}`;
  //   let sql80Query1 = `${sql80Query}${data ? " AND " + data : ""}`;
  //   // let sql80Query1 = `${sql80Query}${data ? " AND " + data : newAdditionalWhere ? " AND " + newAdditionalWhere : "" }`;
  //   // let defaultQuery1 = `${defaultQueryInitial}${data ? " AND " + data : ""}`;
  //   // let sql73Query1 = `${sql73QueryInitial}${data ? " AND " + data : ""}`;
  //   // let sql80Query1 = `${sql80QueryInitial}${data ? " AND " + data : ""}`;
  //   let generateQuery = NOA && NOA == "73" ? sql73Query1 : NOA == "80" ? sql80Query1 : defaultQuery1;

  //   // if(data){
  //   //   setNewQueryData(data);
  //   // }

  //   setAdditionalWhere(generateQuery);
  //   setPage(1);
  // };

  // const handleFilterChange = (data) => {
  //   let defaultQuery1 = `${defaultQuery}`;
  //   let sql73Query1 = `${defaultQuery}${data ? " AND " + data : ""}`;
  //   let sql80Query1 = `${defaultQuery}` //`${defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O'${data ? " AND " + data : ""}`;
  //   let sql51Query1 = `${defaultQuery} AND (NatureTitle LIKE 'ACTING APPOINTMENT' OR NatureTitle LIKE 'DETAIL APPOINTMENT')${data ? " AND " + data : ""}`;

  //   let generateQuery = NOA && NOA == "73" ? sql73Query1 : NOA == "80" ? sql80Query1 : NOA == "51" ? sql51Query1 : defaultQuery1;
  //   setAdditionalWhere(generateQuery);
  //   setPage(1);
  // };
  
  const handleFilterChange = (data) => {
    let defaultQuery1 = `${defaultQuery}${data ? " AND " + data : ""}`;
    let sql73Query1 = `${defaultQuery}${data ? " AND " + data : ""}`;
    let sql80Query1 = `${defaultQuery}${data ? " AND " + data : ""}` //`${defaultQuery} AND NatureTitle LIKE 'SALARY INCREMENT' AND EvalType LIKE 'O'${data ? " AND " + data : ""}`;
    let sql51Query1 = `${defaultQuery} AND (NatureTitle LIKE 'ACTING APPOINTMENT' OR NatureTitle LIKE 'DETAIL APPOINTMENT')${data ? " AND " + data : ""}`;
 
    let generateQuery = NOA && NOA == "73" ? sql73Query1 : NOA == "80" ? sql80Query1 : NOA == "51" ? sql51Query1 : defaultQuery1;
 
    console.log("generateQuery", generateQuery, defaultQuery, data)
    setAdditionalWhere(generateQuery);
    setPage(1);
  };

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  const actions = useMemo(() => {
    return [
      {
        action: (props) => {
          console.log("action props", props)
        },
        className: "font-primary",
        style: { cursor: "pointer" },
      },
    ];
  });

  useEffect(() => {
    // if (ColumnsSorted[TransactionHistory] !== undefined) {
    //   setSortedColumns(ColumnsSorted[TransactionHistory]);
    // } else {
    if (visileColumns.length > 0) {
      const data = visileColumns
        .map((p, index) => {
          return {
            field: p.field,
            show: false,
            locked: false,
            width: 200,
            title: p.title,
            filter: "text",
            key: index,
          };
        });
      let newArr = data.concat(visileColumns.filter((item, i) => item.title == data[i].title));
      setSortedColumns(
        filterAllowedColumn(newArr,
          visileColumns.concat(data)
        ),
        "id"
      );
    }
    // }
  }, [visileColumns]);

  return (
    <>
      {
        openHistory ? (
          <div className="customDialog">
            <Dialog
              title={
                props?.title ? (
                  <h3>{props?.title}</h3>
                ) : (
                  <p style={{ display: "none" }}>Data not available!</p>
                )
              }
              onClose={() => { setOpenHistory(false) }}
              className={props ? "customDialogue" : "noDataClass"}
            >

              <Container>
                <ErrorBoundary>
                  <TransactionTable
                    id={TransactionHistory}
                    pageSize={pageSize}
                    totalCount={rowCount}
                    skip={(page - 1) * pageSize}
                    take={pageSize}
                    data={previousData ? previousData : []}
                    sortData={SortData}
                    onFilterChange={handleFilterChange}
                    onSortChange={handleSortChange}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    selectedColumns={sortedColumns}
                    setSortedColumns={setSortedColumns}
                    loading= {Loading}//{false}// loadingSearch }
                    actions={actions}
                    chooseFilterMethod={"normalSearch"}
                    handleClick={(ds) => {
                      dispatch(setLetestData(ds.dataItem));
                      setTimeout(() => {
                        setOpenHistory(false);
                      }, 1000)
                      console.log("987654354131", ds);
                    }}
                    setOpenHistory={setOpenHistory}
                    raiofeild={true}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams} />
                </ErrorBoundary>
              </Container>
            </Dialog>
          </div>
        )
          : ""}
    </>
  );
};

export default memo(TransactionDataTable);
